export default "__VITE_ASSET__DVLvS8iB__"